import styled from 'styled-components';
import { AnchorButton } from 'src/components/core/button';
import { GuestUserIcon } from 'src/assets/guest-user-icon';
import { KIOSK_PRO_MEDIA } from '../../kiosk-pro-shared/kiosk-pro-shared.styles';

export const GuestLoginContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 56px;
  border-radius: 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 36px;

  @media (orientation: landscape) {
    gap: 72px;
  }

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    padding: 40px;
    gap: 56px;
  }

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    padding: 40px;
    gap: 28px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait} {
    padding: 36px;
    border-radius: 24px;
    gap: 24px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    padding: 36px;
    gap: 48px;
  }
`;

export const GuestLoginOptionsTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscape} {
    gap: 14px;
  }
`;

export const SubText = styled.p`
  font-size: 24px;
  white-space: nowrap;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    font-size: 20px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    font-size: 16px;
  }
`;

export const IconContainerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 36px;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    gap: 28px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    gap: 24px;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 220px;
  height: 220px;
  background: #feeded;
  border-radius: 50%;
  margin: 0 auto;

  @media (orientation: portrait) {
    display: none;
  }

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    width: 156px;
    height: 156px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    width: 112px;
    height: 112px;
  }
`;

export const ThemedUserIcon = styled(GuestUserIcon)`
  color: #f64d4d;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    width: 80px;
    height: 80px;
  }
`;

export const GuestButton = styled(AnchorButton)`
  display: inline-block;
  padding: 24px 36px;
  font-weight: 700;
  font-size: 24px;
  text-transform: none;
  border: 4px solid ${({ theme }) => theme.customized.colors.buttonsLinks};
  color: ${({ theme }) => theme.customized.colors.buttonsLinks};
  background-color: ${({ theme }) => theme.colors.white};

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    font-size: 20px;
    padding: 20px 28px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    padding: 14px 24px;
    font-size: 16px;
  }
`;
